import React from 'react'
import Layout from '../components/layout'
import LayoutEN from '../components/en/layout'
import Contact from '../components/contact'
import ContactEN from '../components/en/contact'
import { Container, Row, Col } from 'react-bootstrap'
import ColoredBanner from '../components/ColoredBanner'
import TestimonialCard from '../components/TestimonialCard'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

const TestimonialDetail = ({ content }) => {
  return (
    <div>
      <h4 className="small-fat-blue mb-4">{content.firstParagraph.title}</h4>
      {content.firstParagraph.type === 'paragraph' &&
        content.firstParagraph.text.map((paragraph, index) => <p>{paragraph}</p>)}

      {content.firstParagraph.type === 'list' && (
        <ul>
          {content.firstParagraph.text.map((paragraph, index) => (
            <li>{paragraph}</li>
          ))}
        </ul>
      )}

      <h4 className="small-fat-blue mt-5 mb-4">{content.secondParagraph.title}</h4>

      <div className="mb-5">
        {content.secondParagraph.type === 'paragraph' &&
          content.secondParagraph.text.map((paragraph, index) => <p>{paragraph}</p>)}

        {content.secondParagraph.type === 'list' && (
          <ul className="pl-4">
            {content.secondParagraph.text.map((paragraph, index) => (
              <li className="mb-2">{paragraph}</li>
            ))}
          </ul>
        )}
      </div>

      <div className="pt-4">
        <TestimonialCard {...content} />
      </div>
    </div>
  )
}

const Testimonial = ({ pageContext, location }) => {
  const { content } = pageContext

  if (pageContext.isEnglish)
    return (
      <LayoutEN location={location} linksTo={`kunden/${pageContext.slug}`} title="jobs" lang="en">
        <Container>
          <ColoredBanner
            backgroundColor="green"
            title={pageContext.titel}
            subHeadline={<p className="small-fat-red">CLIENTS</p>}
          >
            <FontAwesomeIcon icon={faChevronLeft} color="rgb(179, 36, 63)" size="sm" className="mr-1" />
            <Link to="/en/clients/#testimonials">Back</Link>
          </ColoredBanner>

          <Row className="my-5">
            <Col xs={12} md={{ span: 6, offset: 3 }}>
              <TestimonialDetail content={content} />
            </Col>
          </Row>
        </Container>
        <ContactEN />
      </LayoutEN>
    )

  return (
    <Layout location={location} linksTo={`clients/${pageContext.slug}`} title="jobs" lang="de">
      <Container>
        <ColoredBanner
          backgroundColor="green"
          title={pageContext.titel}
          subHeadline={<p className="small-fat-red">KUNDEN</p>}
        >
          <FontAwesomeIcon icon={faChevronLeft} color="rgb(179, 36, 63)" size="sm" className="mr-1" />
          <Link to="/kunden/#stimmen">Zurück</Link>
        </ColoredBanner>
        <Row className="my-5">
          <Col xs={12} md={{ span: 6, offset: 3 }}>
            <TestimonialDetail content={content} />
          </Col>
        </Row>
      </Container>
      <Contact />
    </Layout>
  )
}

export default Testimonial
